/* global asosGlobalNamespace, siteChromeGlobalNamespace */
const namespace = (window[asosGlobalNamespace] =
  window[asosGlobalNamespace] || {});
namespace[siteChromeGlobalNamespace] =
  namespace[siteChromeGlobalNamespace] || {};
